import { makeStyles, styled } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 0, 2),
    zIndex: 1200,
    pointerEvents: 'none',
  },
  toolbar: {
    pointerEvents: 'auto',
  },
  menuContainer: {
    position: 'relative',
  },
  button: {
    color: 'var(--bui-fg-primary)',
    borderRadius: 'var(--bui-radius-2)',
    width: 40,
    height: 40,
  },
  buttonActive: {
    backgroundColor: 'var(--bui-bg-solid)',
    color: 'var(--bui-fg-solid)',
    '&:hover': {
      backgroundColor: 'var(--bui-bg-solid)',
    },
  },
  popover: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: theme.spacing(1),
    zIndex: 9999,
  },
}));

export const Menu = styled('ul')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  maxHeight: 400,
  overflowY: 'auto',
});

export const MenuItem = styled('li')({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  gap: 'var(--bui-space-3)',
  padding: 'var(--bui-space-2)',
  whiteSpace: 'nowrap',
  '&:hover, &.selected': { background: 'var(--bui-bg-tint-hover)' },
  '&:active': { background: 'var(--bui-bg-tint-pressed)' },
  '&.disabled': { color: 'var(--bui-fg-disabled)', cursor: 'default' },
  '&.disabled:hover': { background: 'none' },
});

export const MenuItemIcon = styled('span')({
  alignItems: 'center',
  display: 'flex',
  color: 'var(--bui-fg-secondary)',
  justifyContent: 'center',
});

export const SubmenuIndicator = styled('span')({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
});

export const MenuDivider = styled('li')({
  borderTop: '1px solid var(--bui-border)',
  margin: 'var(--bui-space-1) 0',
  listStyle: 'none',
});
